import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import aiService from '@/services/ai.service';

export const fetchChats = createAsyncThunk('ai/fetchChats', async (params, { rejectWithValue }) => {
  try {
    const res = await aiService.chats(params);
    return { res, params };
  } catch (err) {
    return rejectWithValue(err);
  }
});

const aiSlice = createSlice({
  name: 'ai',
  initialState: { items: [], total: 0, page: 1, limit: 20, loading: false, error: null, listRequestId: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChats.pending, (state, { meta }) => {
        state.loading = true;
        state.error = null;
        // Latest-request-wins so a stale (slower) search response can't overwrite a newer fetch.
        state.listRequestId = meta.requestId;
      })
      .addCase(fetchChats.fulfilled, (state, { payload, meta }) => {
        if (meta.requestId !== state.listRequestId) return; // superseded by a newer fetch
        state.loading = false;
        state.items = payload.res.data || [];
        state.total = payload.res.pagination?.total ?? payload.res.total ?? state.items.length;
        state.page = payload.res.pagination?.page ?? payload.params?.page ?? 1;
        state.limit = payload.res.pagination?.limit ?? payload.params?.limit ?? state.limit;
      })
      .addCase(fetchChats.rejected, (state, { payload, error, meta }) => {
        if (meta.requestId !== state.listRequestId) return; // superseded by a newer fetch
        state.loading = false;
        state.error = payload || { message: error.message };
      });
  },
});

export default aiSlice.reducer;
